import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { formatIstFullDateTime } from "../../utils/dateTime";

const parseMedia = (value) => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [parsed];
  } catch (error) {
    return [value];
  }
};

const getPostValue = (post, keys) => {
  for (const key of keys) {
    if (post?.[key]) {
      return post[key];
    }
  }
  return "";
};

const isImage = (url) => /\.(png|jpe?g|webp|gif|bmp|svg)(\?.*)?$/i.test(String(url));

const PostPreviewModal = ({ post, onClose }) => {
  if (!post) {
    return null;
  }

  const englishText = getPostValue(post, ["biotext_en", "post_text_en", "english_text"]);
  const originalText = getPostValue(post, ["biotext", "post_text", "original_text"]);
  const media = parseMedia(getPostValue(post, ["mediarr", "post_media"]));

  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-post-preview-modal" onClick={(event) => event.stopPropagation()}>
        <div className="admin-post-preview-header">
          <div>
            <p>Post Content</p>
            <span>{getPostValue(post, ["fullname", "reported_user_name", "post_owner_name"]) || "Unknown user"}</span>
          </div>
          <button onClick={onClose} title="Close">
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="admin-post-preview-body">
          <div className="admin-post-preview-meta">
            <span>{post.created_at ? formatIstFullDateTime(post.created_at) + " IST" : "-"}</span>
            <span>{post.visibility ? "Visible: " + post.visibility : null}</span>
            <span>{post.reports_count ? "Reports: " + post.reports_count : null}</span>
          </div>

          <div className="admin-post-preview-section">
            <label>English Content</label>
            <p>{englishText || originalText || "No text content available"}</p>
          </div>

          {originalText && englishText && originalText !== englishText ? (
            <div className="admin-post-preview-section">
              <label>Original Content</label>
              <p>{originalText}</p>
            </div>
          ) : null}

          {media.length > 0 ? (
            <div className="admin-post-preview-section">
              <label>Media</label>
              <div className="admin-post-preview-media-grid">
                {media.map((item, index) => (
                  isImage(item) ? (
                    <a href={item} target="_blank" rel="noreferrer" key={index}>
                      <img src={item} alt="" />
                    </a>
                  ) : (
                    <a className="admin-post-preview-media-link" href={item} target="_blank" rel="noreferrer" key={index}>
                      View attachment {index + 1}
                    </a>
                  )
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PostPreviewModal;
